const dtGenerator = require('../../../../../components/dt/dt-generator')
const dtHandler = require('../../../../../components/dt/dt-handler')
const dtSearch = require('../../../../../components/dt/dt-search')
const clientActivityMenu = require('./clientActivity-menu')
const { organizeRow } = require('./clientActivity-dt-handler')
const { tableDetail } = require('./clientActivity-dt-handler')
const clientActivityFetch = require('./clientActivity-fetch')
const settings = require('../../../../../js-handler/settings')

/****************ELEMENTS*****************/
var htmlDt = {}
var HTMLwasSelected = false
var iframe;


function HTMLselect() {

      dtHandler.HTMLselect('clientActivity-dt', htmlDt, organizeRow, tableDetail)
      iframe = document.getElementById("reportIframe") ?? null;
      HTMLwasSelected = true
}/**/
/****************ELEMENTS*****************/

export function start(detail) {  //console.log('clientActivity-dt 5>', detail)

      if (!HTMLwasSelected) { HTMLselect() }

      obj[detail.act].start(detail)

}/**/

const obj = {

      //From fullcont connection    
      addRow: { start: (detail) => { dtGenerator.addRow(detail, htmlDt) } },
      tableOptions: { start: (detail) => { clientActivityMenu.start(detail, htmlDt, 'htmlFc', settings.getData()) } },
      trMenu: { start: (detail) => { clientActivityMenu.start(detail, htmlDt, 'htmlFc', settings.getData()) } },
      updateRow: { start: (detail) => { dtGenerator.updateRow(detail, htmlDt) } },
      //data table
      filter: { start: (detail) => { dtSearch.filter(detail, htmlDt) } },
      filterShowHide: { start: (detail) => { dtSearch.filterShowHide(detail, htmlDt) } },
      loadMore: { start: (detail) => { dtSearch.loadMore(detail, htmlDt) } },
      searching: { start: (detail) => { dtSearch.searching(detail, htmlDt) } },
      select: { start: (detail) => { select(detail, htmlDt) } },
      th: { start: (detail) => { dtSearch.th(detail, htmlDt) } },

}/**/

function select(detail, htmlDt) {
      dtSearch.select(detail, htmlDt, true, fillSpan);
      showCompanyName()

      const fetchDetail = {
            dest: "provider",
            elem: "report",
            reportType: "accountPayableAll",
      };

      clientActivityFetch.fetchAll(fetchDetail, (data) => {
            if (!Array.isArray(data) || data.length === 0) {
                  return;
            }
      });

      setDataSetPrintBtn();
      setDataDetaiilPrintBtn();
      setLabelTitle();
}

function fillSpan(data) {
      const title = htmlDt.entityDt.querySelector(".title");
      const col1 = htmlDt.dtHeader.querySelector(".col-1");
      const col2 = htmlDt.dtHeader.querySelector(".col-2");
      const col3 = htmlDt.dtHeader.querySelector(".col-3");
      const col4 = htmlDt.dtHeader.querySelector(".col-4");
      const col5 = htmlDt.dtHeader.querySelector(".col-5");

      title.innerHTML = "Total: " + data[0].grand_total_all;
      col1.innerHTML = "Current: " + data[0].grand_total_current;
      col2.innerHTML = data[0].grand_total_due_30_days;
      col3.innerHTML = data[0].grand_total_due_31_to_60_days;
      col4.innerHTML = data[0].grand_total_due_61_to_90_days;
      col5.innerHTML = data[0].grand_total_due_over_90_days;
}

function setLabelTitle() {
      const label = document.querySelector('#clientActivityLabelPrint')
      const entity = settings.getData().entity

      label.innerHTML = `Account ${entity == 'clientCustomer' ? 'Payable' : 'Receivable'}`;
}

function setDataSetPrintBtn() {
      const btnPrintReport = document.querySelectorAll('.clientActivityBtnPrint')
      const entity = settings.getData().entity
      const report = `${entity == 'clientCustomer' ? 'account-receivable-one' : 'account-payable-one'}`
      let data;
      let dataAttributeReport;

      data = {
            "click": [
                  { "dest": "ripple" },
                  {
                        "dest": "clientActivity",
                        "elem": "report",
                        "reportType": "printOrder",
                        "report": `${report}`,
                        "entity": `${entity == 'clientCustomer' ? 'customer' : 'provider'}`,
                        "dbid": `${settings.getData().id}`
                  }
            ]
      };

      dataAttributeReport = JSON.stringify(data);
      btnPrintReport.forEach((e) => {
            e.setAttribute('data-detail', dataAttributeReport)
      })

}

function setDataDetaiilPrintBtn() {
    const cont = document.querySelector('#clientActivityViewBtn')
    const btnPrintReport = document.querySelectorAll('.clientActivityBtnDetail')
    const entity = settings.getData().entity

    // Corrección de la condición: Se usa === para comparar
    if (entity !== 'clientCustomer') {
        cont.classList.add('dn')
        return
    }

    // Si la entidad es 'clientCustomer', se remueve la clase ocultar
    cont.classList.remove('dn')

    const report = entity === 'clientCustomer' ? 'account-receivable-detail' : null
    let data;
    let dataAttributeReport;

    data = {
        "click": [
            { "dest": "ripple" },
            {
                "dest": "clientActivity",
                "elem": "report",
                "reportType": "printOrder",
                "report": `${report}`,
                "entity": entity === 'clientCustomer' ? 'customer' : 'provider',
                "dbid": `${settings.getData().id}`
            }
        ]
    };

    dataAttributeReport = JSON.stringify(data);
    btnPrintReport.forEach((e) => {
        e.setAttribute('data-detail', dataAttributeReport)
    })
}

function showCompanyName() {
      const titleAppBar = document.querySelector("#appbar").querySelector("h1");
      titleAppBar.textContent = `${settings.getData().company} - ${settings.getData().name}`;
}